// CACHE_BUST: v2025-10-01-17:00 - Force bundle regeneration
import 'react-native-get-random-values'
import 'react-native-url-polyfill/auto'
// Polyfill removed from here - will be loaded conditionally in web entry point
import React, { useEffect, useState, useRef } from 'react'
import { Platform } from 'react-native'
import { Amplify } from 'aws-amplify'
import { fetchAuthSession, signOut } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'
import * as NavigationBar from 'expo-navigation-bar'
import { GlobalImageOverlay } from './src/components/customUtils/Components/PinchZoomImage'

// Import web-specific styles (only for web platform)
if (typeof document !== 'undefined') {
    require('./web/web-styles.css')
}
import awsconfig from './src/aws-exports'
import { Provider } from 'react-redux'
import {
    addColumnIfMissing,
    DATABASE_CONFIG,
    deleteAllTables,
    deleteDB,
    getGlobalVersion,
    getUser,
    migrateDatabase,
    openDB,
    updateGlobalVersion,
    USER_PROFILE,
} from './src/db/indexDB'
import { Image, View, Text, Dimensions, Animated, KeyboardAvoidingView, ActivityIndicator, AppState, Alert, TextInput } from 'react-native'
import { getPlatform } from './src/utils/platformUtils'
import Main from './src/components/Main'
import WebLayout from './src/components/web/WebLayout'
import DiagnosticsBoundary from './src/components/dev/DiagnosticsBoundary'
import { GestureHandlerRootView } from 'react-native-gesture-handler'
import theme from './theme'
import SizeCache from './src/utils/sizeCache'
import { LogBox } from 'react-native'
import { store } from './src/redux/store'
import { VERSION_DATABASE, apiUrl } from './src/config/config'
import { LocalizationState } from './src/components/appBar/context/LocalizationContext'
import Splash from './src/components/Splash'
import { PostsServices } from './database/posts.database'
import { TrackingServices } from './database/tracking.database'
import { StatusBar } from 'react-native'
import styles from './AppStyles'
import * as SplashScreen from 'expo-splash-screen'
import NetInfo from '@react-native-community/netinfo'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { eventEmitter } from './src/utils/functions.utils'
import { VerificationProvider } from './src/components/appBar/context/VerificationContext'
import { LoginTheme } from './themeConstants'
import { usePermissionStore } from './src/redux/zustand/permissions-store'
import * as Location from 'expo-location'
import * as ImagePicker from 'expo-image-picker'
// TEMPORARILY REMOVED - Expo Go doesn't support custom native modules
// import 'react-native-reanimated' // Required for reanimated to work
import { AlertsState } from './src/components/appBar/context/AlertsContext'
import { UserServices } from './database/user.database'
import CustomAlert from './src/components/customUtils/Components/CustomAlert'
import { navigate } from './src/components/navigation/hooks/RootNavigation'
import { ASYNC_STORAGE_KEYS } from './src/components/stores/constants/constants.storage'
import { useProgressSchedule } from './src/redux/zustand/progressScheduleStore'
import { SCHEDULES_STORE_NAMES, LEARNING_STORE_NAMES } from './src/db/constants'
import RenderHTML from 'react-native-render-html'
import { useStatusBarColorStore } from './src/redux/zustand/statusBarColorStore'
import { useDataPendingSendStore } from './src/redux/zustand/dataPendingSendStore'
import { SafeAreaProvider } from 'react-native-safe-area-context'

// Performance Monitoring
import PerformanceMonitor from './src/components/PerformanceMonitor'
import productionLogger from './src/utils/productionLogger'
import { setupAPIPerformanceMonitoring, registerPerformanceCallback } from './src/utils/apiPerformanceInterceptor'
import { PERFORMANCE_MONITOR_ENABLED } from './src/config/config'
import { useKeyboardStatus } from './src/hooks/useKeyboardStatus'
import { WebMobileAlert } from '@/components/modals/WebMobileAlert'
import { useBreakpoint, useDimensionsStore } from '@/redux/zustand/useDimensionStore'
import './src/utils/extensions/array.extensions'
import './src/utils/extensions/string.extensions'

// import * as FileSystem from 'expo-file-system'

// Evita que el splash screen se oculte automáticamente
SplashScreen.preventAutoHideAsync()

// Polyfill para web: algunas libs (p.ej. @gorhom/bottom-sheet) esperan 'global'
if (typeof window !== 'undefined' && typeof (window as any).global === 'undefined') {
    ;(window as any).global = window
}

// Debug para web: será manejado en el componente principal

// Configurar Amplify v6 con debug mode para investigar
try {
    Amplify.configure(awsconfig)

    // Activar logs de debug para investigar el problema iOS
    if (getPlatform().OS === 'ios') {
        console.log('🍎 iOS: Activating Amplify debug mode')
        Amplify.configure(awsconfig, {
            ssr: false,
        })
    }

    console.log('✅ Amplify configured successfully')
    console.log('🔧 AWS Config details:', {
        region: awsconfig.aws_project_region,
        userPoolId: awsconfig.aws_user_pools_id,
        userPoolWebClientId: awsconfig.aws_user_pools_web_client_id,
        identityPoolId: awsconfig.aws_cognito_identity_pool_id,
    })
} catch (error) {
    console.error('❌ Error configuring Amplify:', error)
}
const amplifyConfigured = true

// Sanitizamos console.warn: la versión anterior hacía `warning.apply` sobre un string y podía lanzar errores.
// Si se desea silenciar todos los warnings, mantenemos LogBox y convertimos warn en un passthrough seguro.
const __originalConsoleWarn = console.warn
LogBox.ignoreAllLogs()
console.warn = (...args: any[]) => {
    // Podríamos filtrar mensajes específicos aquí si hiciera falta.
    // return; // <-- Descomentar para silenciar totalmente
    try {
        __originalConsoleWarn(...args)
    } catch (_) {
        // swallow
    }
}
const width = Dimensions.get('window').width

let TextAny = Text as any
let TextInputAny = TextInput as any
let RenderHTMLAny = RenderHTML as any

if (TextAny.defaultProps == null) {
    TextAny.defaultProps = {}
}
TextAny.defaultProps.allowFontScaling = false

if (TextInputAny.defaultProps == null) {
    TextInputAny.defaultProps = {}
}
TextInputAny.defaultProps.allowFontScaling = false

if (RenderHTMLAny.defaultProps == null) {
    RenderHTMLAny.defaultProps = {}
    if (RenderHTMLAny.defaultProps.defaultTextProps == null) {
        RenderHTMLAny.defaultProps.defaultTextProps = {}
    }
}
RenderHTMLAny.defaultProps.defaultTextProps.allowFontScaling = false

function AppMain() {
    const [showGif, setShowGif] = useState(true)
    const fadeAnim = useRef(new Animated.Value(0)).current
    const [viewLogin, setViewLogin] = useState(true)
    const [generalLoader, setGeneralLoader] = useState(false)
    const [generalLoaderCustom, setGeneralLoaderCustom] = useState(false)
    const [textLoop, setTextLoop] = useState(false)
    const [loaderTitle, setLoaderTitle] = useState('')
    const [loaderSubtitle, setLoaderSubtitle] = useState('')
    const [loaderLeyendLoop, setLoaderLeyendLoop] = useState('')
    const [modalReturn, setModalReturn] = useState(false)
    const permission = usePermissionStore()
    const [appState, setAppState] = useState(AppState.currentState)
    const prevAppState = useRef(appState)
    const [progressNumber, setProgressNumber] = useState(0)
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0)
    const [showSecondarySplash, setShowSecondarySplash] = useState(false)
    const [secondarySplashUrl, setSecondarySplashUrl] = useState('')
    const progressSchedule = useProgressSchedule((store) => store.progressSchedule)
    const isVisibleProgressSchedule = useProgressSchedule((store) => store.isVisibleProgressSchedule)
    const statusBarColor = useStatusBarColorStore((store) => store.statusBarColor)
    const setHavePendingData = useDataPendingSendStore((state) => state.setHavePendingData)

    const intervalRef = useRef(null)
    const progressTextArray = [
        'Guardando lista de tiendas',
        `${progressNumber} tiendas guardándose`,
        `No interrumpas el proceso`,
        'Unos segundos más, no cierres la App',
    ]
    useEffect(() => {
        const handleAppStateChange = async (nextAppState) => {
            if (prevAppState.current.match(/inactive|background/) && nextAppState === 'active') {
                console.log('App has come to the foreground!')

                // veriico el stado del permiso de localizacion
                let newStatusLocation: Location.PermissionStatus
                let newStatusMediaLibrary: Location.PermissionStatus

                const platformOS = getPlatform().OS
                if (platformOS == 'android') {
                    let { status } = await Location.getForegroundPermissionsAsync()
                    newStatusLocation = status
                } else {
                    let { status } = await Location.requestForegroundPermissionsAsync()
                    newStatusLocation = status
                }

                let { status } = await ImagePicker.getMediaLibraryPermissionsAsync()
                newStatusMediaLibrary = status

                updateLocationPermission(newStatusLocation === 'granted', newStatusMediaLibrary === 'granted')
            }
            prevAppState.current = nextAppState
            setAppState(nextAppState)
            // Guardar caches cuando vamos a background
            if (nextAppState.match(/inactive|background/)) {
                try {
                    await SizeCache.flush()
                } catch {}
            }
        }

        const subscription = AppState.addEventListener('change', handleAppStateChange)

        return () => {
            subscription.remove()
        }
    }, [])

    const updateLocationPermission = (permission_location: boolean, permission_libraryMedia: boolean) => {
        permission.updatePermissions(
            permission_location,
            permission.hasNotificationPermission,
            permission.hasCameraPermission,
            permission_libraryMedia,
        )
    }

    const [appLoaded, setAppLoaded] = useState(false)

    useEffect(() => {
        // Web: asegurar flush del cache en cierre/recarga de pestaña
        if (Platform.OS === 'web' && typeof window !== 'undefined') {
            const w: any = window as any
            const d: any = typeof document !== 'undefined' ? (document as any) : null
            const canWin = typeof w?.addEventListener === 'function' && typeof w?.removeEventListener === 'function'
            const canDoc = d && typeof d?.addEventListener === 'function' && typeof d?.removeEventListener === 'function'

            const onBeforeUnload = () => {
                try {
                    ;(SizeCache as any).flush?.()
                } catch {}
            }
            const onVisibility = () => {
                try {
                    if (d && d.visibilityState === 'hidden') {
                        ;(SizeCache as any).flush?.()
                    }
                } catch {}
            }

            if (canWin) w.addEventListener('beforeunload', onBeforeUnload)
            if (canDoc) d.addEventListener('visibilitychange', onVisibility)

            return () => {
                if (canWin) w.removeEventListener('beforeunload', onBeforeUnload)
                if (canDoc) d.removeEventListener('visibilitychange', onVisibility)
            }
        }
        return
    }, [])

    useEffect(() => {
        const checkFirstLaunchAndSetup = async () => {
            console.log('App initialization starting...')
            try {
                // Hidratar caches de tamaños/ratios lo antes posible para estabilizar layout inicial
                try {
                    await SizeCache.hydrate()
                } catch (_) {
                    // noop
                }
                console.log('🔍 About to call openDB...')
                console.log('🌐 Platform detected:', getPlatform().OS)

                const { isFirstLaunch, lastVersion } = await checkFirstLaunch()

                console.log('First launch check completed:', { isFirstLaunch, lastVersion })

                if (isFirstLaunch) {
                    let pendings = await UserServices.get_pendings_conections()
                    console.log('pendings:first launch', pendings)

                    if (pendings && pendings.status == 0) {
                        console.log('Tiene pendientes')
                        setHavePendingData(true)
                        console.log('tengo datos para enviar ')
                        await UserServices.deleteAllTablesContents()
                    } else {
                        setHavePendingData(false)
                        await clearAppData()
                    }

                    let db = await openDB()
                    await migrateDatabase(lastVersion)

                    // fn extra para agregar columnas nuevas si no existen (se usaba como refuerzo de migrateDatabase)
                    // await addColumnIfMissing(db, 'date_finish', SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS, 'TEXT')
                }

                await openDB()
                    .then(async (res) => {
                        console.log('🔍 openDB completed successfully')
                        console.log('✅ 2Database adapter initialized for:', getPlatform().OS)

                        // Test a simple query if we're on web
                        if (getPlatform().OS === 'web') {
                            try {
                                console.log('🧪 Testing web database with simple query...')
                                const result = await res.getAllAsync('SELECT name FROM sqlite_master WHERE type="table"')
                                console.log('🎉 Web database test successful. Tables found:', result.length)
                            } catch (testError) {
                                console.warn('⚠️ Web database test failed:', testError)
                            }
                        }

                        setAppLoaded(true)
                    })
                    .catch((error) => {
                        console.error('❌ openDB failed:', error)
                        // Set app loaded anyway to allow user to continue
                        setAppLoaded(true)
                    })
            } catch (error) {
                console.error('🚀 ~ checkFirstLaunchAndSetup ~ error:', error)
                console.log('🚀 Error occurred, setting appLoaded to true')
                setAppLoaded(true)
            }
        }

        checkFirstLaunchAndSetup()
    }, [])

    // Performance Monitoring Setup
    useEffect(() => {
        if (!PERFORMANCE_MONITOR_ENABLED) return

        const setupPerformanceMonitoring = async () => {
            // Setup API interceptor (desarrollo y producción)
            setupAPIPerformanceMonitoring()
            console.log('🔌 API Performance Interceptor enabled')

            if (!__DEV__) {
                // Solo en producción, activar logger
                await productionLogger.enable()
                console.log('📊 Production Performance Logger enabled')
            }
        }

        setupPerformanceMonitoring()

        return () => {
            if (!__DEV__) {
                productionLogger.flush()
            }
        }
    }, [])

    async function setAndroidNavBar() {
        await NavigationBar.setBackgroundColorAsync('#FFFFFF')
        await NavigationBar.setButtonStyleAsync('dark')
    }
    useEffect(() => {
        if (!appLoaded) {
            return
        }

        if (Platform.OS == 'android') setAndroidNavBar()
        SplashScreen.hideAsync()
        // Para debugging: ocultar splash inmediatamente
        const timer = setTimeout(() => {
            console.log('🚀 Timer executed, setting showGif to false')
            setShowGif(false)
        }, LoginTheme.timer) // Oculta el GIF después de 100ms para debugging

        return () => clearTimeout(timer) // Limpia el temporizador si el componente se desmonta
    }, [appLoaded])
    const checkFirstLaunch = async () => {
        try {
            const hasLaunched = await AsyncStorage.getItem('hasLaunched')
            console.log('hasLaunched:', hasLaunched)
            const currentVersion = VERSION_DATABASE //getAppVersion()
            const storedVersion = await AsyncStorage.getItem('appVersion')

            // console.log('currentVersion => ', currentVersion)
            console.log('storedVersion => ', storedVersion)

            // Convertir las versiones a flotantes para hacer comparaciones
            const currentVersionFloat = currentVersion //versionToFloat(currentVersion)
            const storedVersionFloat = storedVersion ? parseInt(storedVersion) : 0 //versionToFloat(storedVersion)
            console.log('currentVersionFloat:', currentVersionFloat)
            console.log('storedVersionFloat:', storedVersionFloat)

            if (hasLaunched === null || storedVersionFloat < currentVersionFloat) {
                console.log('first launch')
                await AsyncStorage.clear()
                await AsyncStorage.setItem('hasLaunched', 'true')
                await AsyncStorage.setItem('appVersion', VERSION_DATABASE.toString())
                return { isFirstLaunch: true, lastVersion: storedVersion }
            }

            return { isFirstLaunch: false, lastVersion: null }
        } catch (error) {
            console.error('Error checking first launch:', error)
            return { isFirstLaunch: false, lastVersion: null }
        }
    }

    const gotoButton = async () => {
        try {
            navigate('PostsList', {})
            setGeneralLoaderCustom(false)
            setGeneralLoader(false)
            setLoaderTitle('')
            setLoaderSubtitle('')
            setProgressNumber(0)
            setCurrentMessageIndex(0)
            await AsyncStorage.setItem(ASYNC_STORAGE_KEYS.STOP_PROCESS_SCHEDULE, 'true')
        } catch (error) {
            console.error('🚀 ~ gotoButton ~ error:', error)
        }
    }

    const clearAppData = async () => {
        try {
            //await AsyncStorage.clear()
            const db = await openDB(true)
            await deleteDB()
            console.log('App data cleared.')
        } catch (error) {
            console.error('Error clearing app data:', error)
        }
    }

    useEffect(() => {
        Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 900, // Duración de la animación en milisegundos
            delay: 500, // Inicia la animación después de 3 segundos
            useNativeDriver: true,
        }).start()
    }, [fadeAnim])

    const checkUser = async (db) => {
        console.log('🔍 checkUser - Starting user verification...')
        try {
            let user = null
            try {
                console.log('🔍 checkUser - About to call getUser(db)...')
                if (db === null) {
                    console.log('🔍 checkUser - DB is null, skipping getUser call (SQLite temporarily disabled)')
                    user = null
                } else {
                    user = await getUser(db)
                }
                console.log('🔍 checkUser - getUser completed. User found:', !!user, user?.login ? 'logged in' : 'not logged in')
                if (!user || (user && !user.login)) {
                    console.log('🔍 checkUser - Setting viewLogin to true (no user or not logged in)')
                    setViewLogin(true)
                    return true
                } else {
                    console.log('🔍 checkUser - User is logged in, setting viewLogin to false')
                    setViewLogin(false)
                }
            } catch (error) {
                console.error('162 ---- checkUser Error: ', error)
                console.log('🔍 checkUser - Error occurred, setting viewLogin to true')
                setViewLogin(true)
                return true
            }
            console.log('🔍 checkUser - About to check network connection...')
            const netInfoState = await NetInfo.fetch()
            console.log('🔍 checkUser - Network state:', netInfoState.isConnected, netInfoState.isInternetReachable)
            if (netInfoState.isConnected && netInfoState.isInternetReachable) {
                console.log('🔍 checkUser - Network available, checking session...')
                let session
                try {
                    console.log('🔍 checkUser - About to call fetchAuthSession()...')
                    session = await fetchAuthSession()
                    console.log('🔍 checkUser - fetchAuthSession completed successfully')
                } catch (error) {
                    console.log('🔍 checkUser - fetchAuthSession failed:', error.message)
                    session = null
                }
                if (session && user) {
                    console.log('------------>>>>>>>>> ESTOY CON UNA SESSION INICIADA~ checkUser ~ session:', DATABASE_CONFIG?.NAME_DB)
                    //verifico version de la baseLocal

                    const versionDB = await AsyncStorage.getItem('appVersion')
                    //let versionDB = await getGlobalVersion(db, DATABASE_CONFIG?.NAME_DB)
                    console.log(DATABASE_CONFIG?.VERSION, '🚀 ~ checkUser ~ versionDB:', versionDB, '<', DATABASE_CONFIG?.VERSION)
                    if (versionDB == null || parseInt(versionDB) < DATABASE_CONFIG?.VERSION) {
                        // // Si la versión almacenada es nula o menor que la actual, ELIMINO DATOS LOCALES
                        console.log('===>Elimino tablas por cambios en tablas ', parseInt(versionDB))
                        await deleteAllTables()
                        let base = await openDB(true)
                        if (base) {
                            //actualizo las versiones
                            await AsyncStorage.setItem('appVersion', VERSION_DATABASE.toString())
                            await updateGlobalVersion(base, DATABASE_CONFIG?.NAME_DB, DATABASE_CONFIG?.VERSION)
                        }
                    } else {
                        console.log('===>Estoy con la version ok de la base local')
                    }
                    //debugger
                    setViewLogin(false)
                    let user = await PostsServices.getUser()
                    if (user != undefined) {
                        TrackingServices.addTracking(user['_id'], 'get_wall', 'posts')
                    } else {
                        console.log('USER:', user)
                    }
                    return true
                } else {
                    setViewLogin(true)
                    return true
                }
            }
            return true
        } catch (error) {
            console.error('� checkUser - Main catch block error:', error)
            setViewLogin(true)
            return true
        } finally {
            console.log('🔍 checkUser - Finally block executed, returning true')
            return true
        }
    }

    useEffect(() => {
        const onStart = () => setGeneralLoader(true)
        const onEnd = () => setGeneralLoader(false)

        eventEmitter.on('starGeneralLoader', onStart)
        eventEmitter.on('endGeneralLoader', onEnd)

        return () => {
            eventEmitter.removeListener('starGeneralLoader', onStart)
            eventEmitter.removeListener('endGeneralLoader', onEnd)
        }
    }, [])

    useEffect(() => {
        const onStartCustom = (title: string, subtitle: string, count: number, textLoop = true) => {
            setGeneralLoaderCustom(true)
            setTextLoop(textLoop)
            if (title && title != '') setLoaderTitle(title)
            if (subtitle && subtitle != '') setLoaderSubtitle(subtitle)
            if (count) setProgressNumber(count)
        }
        const onEndCustom = () => {
            setGeneralLoaderCustom(false)
            setLoaderTitle('')
            setLoaderSubtitle('')
            setProgressNumber(0)
            setCurrentMessageIndex(0)
        }

        eventEmitter.on('starGeneralLoaderCustom', onStartCustom)
        eventEmitter.on('endGeneralLoaderCustom', onEndCustom)

        return () => {
            eventEmitter.removeListener('starGeneralLoaderCustom', onStartCustom)
            eventEmitter.removeListener('endGeneralLoaderCustom', onEndCustom)
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
            }
        }
    }, [])

    const setLoaderInterval = () => {
        intervalRef.current = setInterval(() => {
            // console.log('303 -- sigo iterando: ', intervalRef.current)
            setCurrentMessageIndex((prevIndex) => {
                // const nextIndex = (prevIndex + 1) % progressTextArray.length;
                const nextIndex = prevIndex + 1 == progressTextArray.length ? 0 : prevIndex + 1

                if (nextIndex === 1 && progressNumber === 0) {
                    return nextIndex + 1
                }
                return nextIndex
            })
        }, 5000)
    }

    useEffect(() => {
        let timeoutId
        let intervalId

        if (generalLoaderCustom) {
            timeoutId = setTimeout(() => {
                setModalReturn(true)
                intervalId = setInterval(() => {
                    setModalReturn(true)
                }, 60000) // 1 minuto 60000
            }, 60000) // 2 minutos 120000
        }

        return () => {
            // Limpiar tiempo e intervalo al desactivar el loader
            clearTimeout(timeoutId)
            clearInterval(intervalId)
            setModalReturn(false)
        }
    }, [generalLoaderCustom])

    useEffect(() => {
        if (generalLoaderCustom) {
            setLoaderInterval()
        } else {
            clearInterval(intervalRef.current)
        }
    }, [generalLoaderCustom])

    useEffect(() => {
        if (generalLoaderCustom) {
            if (progressTextArray[currentMessageIndex]) {
                setLoaderLeyendLoop(progressTextArray[currentMessageIndex])
            }
        } else {
            if (!generalLoaderCustom) {
                clearInterval(intervalRef.current)
            }
        }
    }, [currentMessageIndex, generalLoaderCustom])
    const keyboardVisible = useKeyboardStatus()
    const setDimensions = useDimensionsStore((state) => state.setDimensions)
    useEffect(() => {
        const subscription = Dimensions.addEventListener('change', ({ window }) => {
            setDimensions(window)
            console.log('[WebLayout] Window dimensions changed:', window)
        })

        return () => subscription?.remove()
    }, [setDimensions])
    const bp = useBreakpoint()
    if (!appLoaded) {
        return <></>
    }

    return (
        <Provider store={store}>
            <SafeAreaProvider>
                <KeyboardAvoidingView
                    style={[styles.container, Platform.OS == 'android' && { paddingBottom: keyboardVisible ? '4%' : 0 }]}
                    behavior={Platform.OS === 'ios' ? 'padding' : null}
                >
                    <LocalizationState>
                        <StatusBar translucent hidden={false} backgroundColor='transparent' barStyle={statusBarColor} />
                        <AlertsState>
                            <VerificationProvider>
                                {PERFORMANCE_MONITOR_ENABLED ? (
                                    <GestureHandlerRootView style={styles.container}>
                                        {showGif ? (
                                            <Splash />
                                        ) : (
                                            <DiagnosticsBoundary name='MainRoot'>
                                                <Main />
                                            </DiagnosticsBoundary>
                                        )}
                                        {/* Monitor visual para DESARROLLO */}
                                        {__DEV__ && <PerformanceMonitor position='top-right' enabled={true} />}

                                        {generalLoader && (
                                            <View style={styles.containerLoader}>
                                                <ActivityIndicator color={'white'} size={50} />
                                            </View>
                                        )}

                                        {generalLoaderCustom && (
                                            <>
                                                <View style={styles.containerLoaderWhite}>
                                                    <View style={styles.containerGif}>
                                                        <Image
                                                            source={require('./assets/circleLoader.gif')} // Usa la importación del GIF
                                                            style={{ width: width / 6, height: width / 6 }} // Ajusta el tamaño según necesites
                                                            resizeMode='contain' // O "cover", dependiendo de cómo quieras que se ajuste
                                                        />

                                                        {loaderTitle && loaderTitle != '' && (
                                                            <Text style={styles.loaderText}>
                                                                {loaderTitle} {isVisibleProgressSchedule && JSON.stringify(progressSchedule) + '%'}
                                                            </Text>
                                                        )}
                                                        {loaderSubtitle && loaderSubtitle != '' && (
                                                            <Text style={styles.description}>{loaderSubtitle}</Text>
                                                        )}
                                                        {textLoop && loaderLeyendLoop && loaderLeyendLoop != '' && (
                                                            <Text style={styles.description}>{loaderLeyendLoop}</Text>
                                                        )}
                                                        {/* {isVisibleProgressSchedule && <Text style={styles.description}>{JSON.stringify(progressSchedule)}%</Text>} */}
                                                    </View>
                                                </View>
                                                {modalReturn && (
                                                    <CustomAlert
                                                        visible={true}
                                                        backgroundColor={theme.colors.error}
                                                        textColor={'white'}
                                                        nameIcon={null}
                                                        message={
                                                            '¡Parece que la conexión está un poco lenta! El proceso podría tardar más de lo normal.'
                                                        }
                                                        onClose={() => setModalReturn(false)} // Cerrar el modal cuando se presiona el icono 'X'
                                                        buttonAdditional={{ text: 'Ir al muro', acction: () => gotoButton() }}
                                                    />
                                                )}
                                            </>
                                        )}
                                        {/* Overlay global para zoom de imágenes */}
                                        <GlobalImageOverlay />
                                    </GestureHandlerRootView>
                                ) : (
                                    <GestureHandlerRootView style={styles.container}>
                                        {showGif ? (
                                            <Splash />
                                        ) : (
                                            <DiagnosticsBoundary name='MainRoot'>
                                                <Main />
                                            </DiagnosticsBoundary>
                                        )}

                                        {generalLoader && (
                                            <View style={styles.containerLoader}>
                                                <ActivityIndicator color={'white'} size={50} />
                                            </View>
                                        )}

                                        {generalLoaderCustom && (
                                            <>
                                                <View style={styles.containerLoaderWhite}>
                                                    <View style={styles.containerGif}>
                                                        <Image
                                                            source={require('./assets/circleLoader.gif')} // Usa la importación del GIF
                                                            style={{ width: width / 6, height: width / 6 }} // Ajusta el tamaño según necesites
                                                            resizeMode='contain' // O "cover", dependiendo de cómo quieras que se ajuste
                                                        />

                                                        {loaderTitle && loaderTitle != '' && (
                                                            <Text style={styles.loaderText}>
                                                                {loaderTitle} {isVisibleProgressSchedule && JSON.stringify(progressSchedule) + '%'}
                                                            </Text>
                                                        )}
                                                        {loaderSubtitle && loaderSubtitle != '' && (
                                                            <Text style={styles.description}>{loaderSubtitle}</Text>
                                                        )}
                                                        {textLoop && loaderLeyendLoop && loaderLeyendLoop != '' && (
                                                            <Text style={styles.description}>{loaderLeyendLoop}</Text>
                                                        )}
                                                        {/* {isVisibleProgressSchedule && <Text style={styles.description}>{JSON.stringify(progressSchedule)}%</Text>} */}
                                                    </View>
                                                </View>

                                                {modalReturn && (
                                                    <CustomAlert
                                                        visible={true}
                                                        backgroundColor={theme.colors.error}
                                                        textColor={'white'}
                                                        nameIcon={null}
                                                        message={
                                                            '¡Parece que la conexión está un poco lenta! El proceso podría tardar más de lo normal.'
                                                        }
                                                        onClose={() => setModalReturn(false)} // Cerrar el modal cuando se presiona el icono 'X'
                                                        buttonAdditional={{ text: 'Ir al muro', acction: () => gotoButton() }}
                                                    />
                                                )}
                                            </>
                                        )}
                                        {/* Overlay global para zoom de imágenes */}
                                        <GlobalImageOverlay />
                                    </GestureHandlerRootView>
                                )}
                                {Platform.OS == 'web' && bp === 'sm' && <WebMobileAlert />}
                            </VerificationProvider>
                        </AlertsState>
                    </LocalizationState>
                </KeyboardAvoidingView>
            </SafeAreaProvider>
        </Provider>
    )
}

export default AppMain
